import { ADDRESS_BILLING_CATEGORY } from 'services/constants/cart';
import { DESTINATION_TYPES } from '../../../constants';
import type { BillingType } from '../../../types';

/** Maps the billing form type to the category expected by the billing API. */
export function getBillingCategory(billingType: BillingType) {
  // Convert the UI form type back to the category expected by the billing API.
  return billingType === DESTINATION_TYPES.COMPANY
    ? ADDRESS_BILLING_CATEGORY.COMPANY
    : ADDRESS_BILLING_CATEGORY.PERSONAL;
}
